import { Component } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'emodnet-fe-save-dialog',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './save-dialog.component.html',
  styleUrl: './save-dialog.component.scss'
})
export class SaveDialogComponent {
  public value: string = '';
  public error: boolean = false;
  public errorText: string = '';

  constructor(private dialogRef: MatDialogRef<SaveDialogComponent>) { }

  close() {
    this.dialogRef.close();
  }

  public allowOnlyValidChars(event: KeyboardEvent, inputElement: any) {
    let charNotPermitted = event.key.match(/^[a-zA-Z0-9#$%^&()@!]$/g) === null;
    if (charNotPermitted && inputElement.selectionStart === 0) {
      event.preventDefault();
      return;
    }
  }

  public save() {
    if (this.value[this.value.length - 1] === " ") {
      this.error = true;
      this.errorText = "The name can't finish with a space";
    } else {
        this.errorText = '';
        this.error = false;
        if (localStorage.length > 0 && localStorage.getItem('custom-filter')) {
          const savedFilter = JSON.parse(localStorage.getItem('custom-filter')!);
          savedFilter.categories.forEach((el: any) => {
            if (el.name === this.value) {
              this.error = true;
              this.errorText = 'Name already used';
            }
          });
          if (!this.error) {
            this.error = false;
            this.errorText = '';
            this.dialogRef.close(this.value.trim());
          }
        } else {
          this.error = false;
          this.errorText = '';
          this.dialogRef.close(this.value.trim());
        }
    }
  }
}
